var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    clipPath: "url(#clip0_275_1501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.27745 18.1748L16.0602 4.79913L13.9123 2.8977L2.11856 16.2856L1.18604 18.9163C1.14104 19.0582 1.17809 19.1851 1.2972 19.2972C1.4163 19.4093 1.54335 19.434 1.67834 19.3714L4.27745 18.1748ZM17.0121 3.74239L18.1043 2.52613C18.3774 2.20758 18.5121 1.89786 18.5084 1.59697C18.5046 1.29608 18.3634 1.0194 18.0848 0.766919L17.6675 0.399746C17.3894 0.154959 17.0993 0.0537852 16.797 0.0962244C16.4947 0.138668 16.2065 0.311473 15.9324 0.614639L14.841 1.84244L17.0121 3.74239Z",
    fill: "#312E28"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_1501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5835,
    height: 20,
    fill: "white",
    transform: "translate(0.366821)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.b3dd3fcfdbac5417b5560dfc203d0cfb.svg";
export { ForwardRef as ReactComponent };